import React from "react";
import {PatternBackground} from "../../components/PatternBackground";
import {TwoTextCard} from "../../components/TwoTextCard";
import ResponsiveGridCard from "../../components/ResponsiveGridCard";

export const MemberView = () => {
  return (
      <div className="">
        <PatternBackground>
          <h1 className="fw-bold mb-5">Jordan Sam</h1>
            <div className="row">
                <ResponsiveGridCard colSizes={{xs: 12, sm: 6, md: 4, lg: 2}}>
                    <TwoTextCard title='22 Aug 2020' subText='Date of birth' color='#FFF'/>
                </ResponsiveGridCard>
                <ResponsiveGridCard colSizes={{xs: 12, sm: 6, md: 4, lg: 2}}>
                    <TwoTextCard title='22 Aug 2020' subText='Date of birth' color='#FFF'/>
                </ResponsiveGridCard>
                <ResponsiveGridCard colSizes={{xs: 12, sm: 6, md: 4, lg: 2}}>
                    <TwoTextCard title='22 Aug 2020' subText='Date of birth' color='#FFF'/>
                </ResponsiveGridCard>
                <ResponsiveGridCard colSizes={{xs: 12, sm: 6, md: 4, lg: 2}}>
                    <TwoTextCard title='22 Aug 2020' subText='Date of birth' color='#FFF'/>
                </ResponsiveGridCard>
                <ResponsiveGridCard colSizes={{xs: 12, sm: 6, md: 4, lg: 2}}>
                    <TwoTextCard title='22 Aug 2020' subText='Date of birth' color='#FFF'/>
                </ResponsiveGridCard>
                <ResponsiveGridCard colSizes={{xs: 12, sm: 6, md: 4, lg: 2}}>
                    <TwoTextCard title='22 Aug 2020' subText='Date of birth' color='#FFF'/>
                </ResponsiveGridCard>
            </div>
        </PatternBackground>
          <div className="om-container">
          <p className="lead mt-5">Beneficiaries</p>
        <div className='p-4 shadow-sm bg-white rounded'>
            <div className="row p-4">
                <ResponsiveGridCard colSizes={{xs: 12, sm: 12, md: 6, lg: 4}}>
                    <div className='shadow p-4 rounded h-100'>
                        <p className="fw-bold mb-0">Cousin</p>
                        <hr/>
                        <TwoTextCard title='Anna-Maria' subText='First Name'/>
                        <TwoTextCard title='Oppong-Brenya' subText='Last Name'/>
                        <TwoTextCard title='9th Aug 1997' subText='Date of Birth'/>
                        <TwoTextCard title='Ghana Card' subText='ID Type'/>
                        <TwoTextCard title='GHA-3393923-2' subText='ID Number'/>
                        <TwoTextCard title='50%' subText='Percent Allocation'/>
                        <hr/>
                        <p className="fw-bold mb-0"><i className="bi bi-telephone-fill"/> 0209386780</p>
                    </div>
                </ResponsiveGridCard>
                <ResponsiveGridCard colSizes={{xs: 12, sm: 12, md: 6, lg: 4}}>
                    <div className='shadow p-4 rounded h-100'>
                        <p className="fw-bold mb-0">Cousin</p>
                        <hr/>
                        <TwoTextCard title='Anna-Maria' subText='First Name'/>
                        <TwoTextCard title='Oppong-Brenya' subText='Last Name'/>
                        <TwoTextCard title='9th Aug 1997' subText='Date of Birth'/>
                        <TwoTextCard title='Ghana Card' subText='ID Type'/>
                        <TwoTextCard title='GHA-3393923-2' subText='ID Number'/>
                        <TwoTextCard title='50%' subText='Percent Allocation'/>
                        <hr/>
                        <p className="fw-bold mb-0"><i className="bi bi-telephone-fill"/> 0209386780</p>
                    </div>
                </ResponsiveGridCard>
            </div>
        </div>
          </div>
      </div>
  )
}